import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery'
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
import DropDownCellIntervalosSelos from './myDropDownCellIntervalosSelo';
// export const DropDownCellProduto = props => {
  
var optionsSerie = [];
var DropDownCellTipoVasilha = null;
var valueSelected = '';
var IdSerieSelo = null;
var entidadeSerie;
class DropDownCellSeriesSelo extends Component {
 
  handleChange = e => {
    $("#id-Intervalo .k-input").empty()

    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });

    IdSerieSelo = e;    

    $('#id-Series-Selo').html(e.value.value);
   
    DropDownCellIntervalosSelos.ChangeValueById(IdSerieSelo , entidadeSerie);
  }

  static ChangeValueById(id , entidade){
    entidadeSerie = entidade
    console.log('DropDownCellSerieSelo')
    optionsSerie = [];
    (async () => {
      if(id.value.value != undefined){
        var valor = id.value.value
      }else{
        var valor = id.value
      }
      const data = {
        "idEntidade": entidadeSerie,
        "idTipoSelo": valor
      }

        const SerieSelo = await services.apiCall.requestApi(
          "/Selos/GetSeriesEntidade",
          data,
          "get"
        );

        if(SerieSelo){
         
          SerieSelo.map((selo) => (
            optionsSerie.push({text: selo.serie, value: selo.idRegistoSelo})
          ));     
        }else{
          optionsSerie = [];
        };        
    })();

  }

  componentDidMount = () => {

    // myFunction();

  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
                popupSettings={{
                  width: 'max-content',
                }}
                onChange={this.handleChange}
                value={optionsSerie.length > 0 ? optionsSerie.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null)): dataItem.Serie_selosGarantia}
                data={optionsSerie}
                textField="text"
                id='id-SerieSelo'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
    );
  }
}

export default DropDownCellSeriesSelo;